import { render, staticRenderFns } from "./PositionFuturesRecords.vue?vue&type=template&id=a7fa4686&scoped=true"
import script from "./PositionFuturesRecords.vue?vue&type=script&lang=js"
export * from "./PositionFuturesRecords.vue?vue&type=script&lang=js"
import style0 from "./PositionFuturesRecords.vue?vue&type=style&index=0&id=a7fa4686&prod&lang=scss&scoped=true"
import style1 from "./PositionFuturesRecords.vue?vue&type=style&index=1&id=a7fa4686&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fa4686",
  null
  
)

export default component.exports